"use client";

import { Providers } from "./providers";
import InteractiveAvatar from "@/components/InteractiveAvatar";
import VoicePreviewApp from "@/components/VoicePreview";
import { Button } from "@nextui-org/react";
import { useState } from "react";



export default function App() {
  const [activeTab, setActiveTab] = useState("demo");

  const tabs = [
    {
      id: "demo",
      label: "Demo",
      content: <InteractiveAvatar />
    },
    
    // {
    //   id: "code",
    //   label: "Code",
    //   content: <InteractiveAvatarCode />,
    // },
   {
      id: "voices",
      label:"Voices",
      content: <VoicePreviewApp />,
    }
  ];

  return (
    <Providers themeProps={{ attribute: "class", defaultTheme: "dark" }}>
      <div className="w-full min-h-screen flex flex-col">
      <div className="flex-grow flex flex-col items-center justify-start gap-5 mx-auto pt-4 pb-20 overflow-auto w-full max-w-7xl px-4">
        {tabs.find(tab => tab.id === activeTab)?.content}
      </div>
      <div className="w-full flex justify-center gap-4 p-4 bg-gray-100 dark:bg-gray-800">
        {tabs.map((tab) => (
          <Button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            color={activeTab === tab.id ? "primary" : "default"}
          >
            {tab.label}
          </Button>
        ))}
      </div>
    </div>
    </Providers>
  );
}
